














import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Selector from '@ui/Inputs/Selector'

settings =
  name: 'VenueSelector'

  vue:
    props: ['selectedOptions', 'theme', 'actions']

    components: {
      Selector,
    }

    data: ->
      venueOptions: []

    mounted: ->
      @searchVenue()

    computed:
      selectorActions: -> { ...@actions, search: @searchVenue }

      selectorOptions: ->
        searchBoxPlaceholder: 'Search'
        selectOptionsTitle: false

      selectedKeys: ->
        @selectedOptions.map((item) => item.id)

    methods:
      searchVenue: (value = '') ->
        text = value.trim()
        @venueOptions = []
        items = await RecessAPI.search 'venues', { text, per_page: 100 }
        options = []
        for item in items
          options.push({
            key: item.id,
            value: item.name,
            type: 'venue',
            sortBy: "#{item.name}",
            data: item
          })
        @venueOptions = options.sort((a, b) -> "#{a.value}".localeCompare("#{b.value}"))

export default VueOptions.vue settings
